module.exports = __webpack_public_path__ + "img/ibkr-dark.745c429d.png";